import React, { useEffect, useState } from "react";
import TextInput from "../../Global Functions/textInput";

const OfficeSpace = ({ onChange, propertyDataBackend }) => {
  const [propertyData, setPropertyData] = useState({
    total_quantity: "",
    no_of_seatings: "",
    rental_yield_percentage: "",
    no_of_pantry: "",
    no_of_bathroom: "",
  });

  useEffect(() => {
    if (propertyDataBackend) {
      setPropertyData({
        total_quantity: propertyDataBackend.total_quantity || "",
        rental_yield_percentage:
          propertyDataBackend.rental_yield_percentage || "",
        no_of_seatings: propertyDataBackend.rental_yield_percentage || "",
        no_of_pantry: propertyDataBackend.no_of_pantry || "",
        no_of_bathroom: propertyDataBackend.no_of_bathroom,
      });
    }
  }, [propertyDataBackend]);

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    const updatedState = { ...propertyData, [name]: value };
    setPropertyData((prevData) => ({ ...prevData, [name]: value }));
    if (onChange) {
      onChange(updatedState);
    }
  };

  return (
    <div className="grid-span-2">
      <div className="grid-template-2 gap-10">
        <TextInput
          label="No. of Units"
          onChange={handleAddChange}
          required
          min={0}
          value={propertyData.total_quantity}
          name="total_quantity"
        ></TextInput>
        <TextInput
          label="Seating Capacity"
          onChange={handleAddChange}
          value={propertyData.no_of_seatings}
          required
          min={0}
          name="no_of_seatings"
        ></TextInput>
        <TextInput
          label="Bathroom(s)"
          onChange={handleAddChange}
          value={propertyData.no_of_bathroom}
          required
          min={0}
          name="no_of_bathroom"
        ></TextInput>
        <TextInput
          label="Pantry(s)"
          onChange={handleAddChange}
          required
          min={0}
          name="no_of_pantry"
          value={propertyData.no_of_pantry}
        ></TextInput>
        <TextInput
          label="Rental Yield(%)"
          onChange={handleAddChange}
          required
          min={0}
          value={propertyData.rental_yield_percentage}
          name="rental_yield_percentage"
        ></TextInput>
      </div>
    </div>
  );
};

export default OfficeSpace;
